import "../styles/AboutUs.css"

import Banner from "./navigation/Banner"
import NavBar from "./navigation/NavBar"
import Footer from "./navigation/Footer"

import aboutUsPic from "../images/oliver-about-us.jpg"

function AboutUs() {
  return (
    <div className="about-us-page-container" >
      <Banner />
      <NavBar />

      <div className="about-us-page-content-container">
        <div className="about-us-content-1">
          <h1>About Us</h1>
        </div>

        <div className="about-us-content-2">
          <div className="about-us-description-container">
            <span className="about-us-description">
              Located in the heart of Little Italy
              on historic Federal Hill,
              Roma first opened it's doors in 1983.
            </span>
          </div>

          <img className="about-us-pic" src={aboutUsPic} alt="Store manager" />
        </div>

        <div className="about-us-content-3">
          <h2 className="about-us-content-3-title">Same Great Food, With New Flair!</h2>
        </div>

        <Footer />

      </div>
    </div>
  )
}

export default AboutUs
